import { Form, Select, Button, DatePicker } from "antd";
import find from "lodash/find";
import map from "lodash/map";
import get from "lodash/get";

import { getButtonDisabled } from "../../../utilities/helpers";

const HeaderSelector = ({
  filter,
  config,
  form,
  setFilters,
  getCompanyParts,
  getDetails,
  setConfig,
  setPartDetails
}) => {
  return (
    <div className="w-fit px-8 py-6">
      <div className="md:justify-end flex items-start md:items-center flex-wrap h-full gap-2 md:gap-0 md:space-x-5">
        <Form.Item
          name="Company"
          label="Company"
          colon={false}
          layout="vertical"
        >
          <Select
            style={{ minWidth: 250 }}
            size="middle"
            value={get(filter, "company")}
            placeholder="Select Company"
            options={map(get(config, "companies"), (company) => ({
              label: get(company, "name"),
              value: get(company, "id"),
            }))}
            optionFilterProp="label"
            showSearch
            onChange={(val) => {
              const company = find(get(config, "companies"), ["id", val]);
              setFilters({
                ...filter,
                company: company,
                templateType: undefined,
                part:undefined
              });
              setConfig({
                ...config,
                templates: get(company, "template_access_list"),
              });
              form.setFieldsValue({
                template: undefined,
                part: undefined,
              });
              setPartDetails(undefined)
            }}
          />
        </Form.Item>
        <Form.Item
          name="template"
          label="Template"
          colon={false}
          layout="vertical"
        >
          <Select
            style={{ minWidth: 250 }}
            size="middle"
            placeholder="Select Template"
            options={map(get(config, "templates"), (template) => ({
              label: get(template, "name"),
              value: get(template, "value"),
            }))}
            value={get(filter, "templateType")}
            onChange={(value) => {
              getCompanyParts(get(filter, "company"), { type: value });
              setFilters({
                ...filter,
                templateType: value,
                part:undefined
              });
              setPartDetails(undefined)
              form.setFieldsValue({
                part: undefined,
              });
            }}
          />
        </Form.Item>
        <Form.Item name="part" label="Part" colon={false} layout="vertical">
          <Select
            style={{ minWidth: 250 }}
            size="middle"
            placeholder="Select Part"
              optionFilterProp="label"
            showSearch
            options={map(get(config, "parts"), (parts) => ({
              label: get(parts, "name"),
              value: get(parts, "id"),
            }))}
            value={get(filter, "part.id")}
            onChange={(value) => {
              setFilters({
                ...filter,
                part: find(get(config, "parts"), ["id", value]),
              });
              setPartDetails(undefined)
            }}
            filterOption={(input, option) =>
              (option?.label ?? "").toLowerCase().includes(input.toLowerCase())
            }
          />
        </Form.Item>

        <Form.Item
          initialValue={get(filter, "date")}
          name="month"
          label="Month"
          colon={false}
          layout="vertical"
        >
          <DatePicker
            format={"MM-YYYY"}
            onChange={(value, dateString) => {
              setFilters({
                ...filter,
                date: value,
              });
            }}
            value={get(filter, "date")}
            picker="month"
          />
        </Form.Item>

        <Form.Item name="submit" label=" " colon={false} layout="vertical">
          <Button
            type="primary"
            className="w-30"
            onClick={getDetails}
            disabled={getButtonDisabled(filter, [
              "templateType",
              "company",
              "part",
              "date",
            ])}
          >
            Submit
          </Button>
        </Form.Item>
      </div>
    </div>
  );
};

export default HeaderSelector;
